import client from './client'
import type { SwitchPolicyData, UpsertSwitchPolicyPayload } from '@/types/switch-policy'

export async function fetchSwitchPolicy(editionId: number): Promise<SwitchPolicyData | null> {
  const { data } = await client.get<{ data: SwitchPolicyData | null }>(
    `/organizer/editions/${editionId}/switch-policy`,
  )
  return data.data
}

export async function upsertSwitchPolicy(
  editionId: number,
  payload: UpsertSwitchPolicyPayload,
): Promise<SwitchPolicyData> {
  const { data } = await client.put<{ data: SwitchPolicyData }>(
    `/organizer/editions/${editionId}/switch-policy`,
    payload,
  )
  return data.data
}
